<template>
  <div class="ipaddr">
    <div>{{ip}}</div>
    {{addr}}
  </div>
</template>

<script>
  import App from '../../util/comfun'
  import {jsonp} from 'vue-jsonp'
  export default {
    props:{
      idx:{
        type:Number,
        value:0,
      },
      ip:{
        type:String,
        value:""
      },
    },
    data () {
      return {
        addr:"...",
      }
    },
    methods:{
      init(){
        //console.error('App.ips',this.idx,App.ip2addr[this.ip])
        if(App.ip2addr[this.ip]) {
          if(App.ip2addr[this.ip]!='...'){
            this.addr=App.ip2addr[this.ip]
          }
          return
        }
        App.ip2addr[this.ip]='...'
        let data={
          ip:this.ip,
          key:'355BZ-QN2KJ-VWTF5-FWHIC-XPE6Z-WUBWG',
          output: 'jsonp'
        }
        jsonp('https://apis.map.qq.com/ws/location/v1/ip',data).then(res=>{
          console.log(res)
          if(res.status==0){
            this.addr=res.result.ad_info.province+res.result.ad_info.city
            App.ip2addr[this.ip]=this.addr
          }
        })
      },
    },
    mounted(){
      setTimeout(()=>{
        this.init();
      },parseInt(this.idx*(500+Math.random()*500)))
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/card/ipaddr.vue